module.exports = __webpack_public_path__ + "static/img/mica-3.4e05deb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mica-3.jpg
// module id = EfQL
// module chunks = 1